export default {
  lang: {
    zhCN: '简体中文',
    enUS: 'English'
  },
  common: {
    home: 'Home',
    logout: 'Logout',
    language: 'Language',
    loading: 'Loading...',
    noMore: 'No more',
    pullToLoadMore: 'Pull to load more',
    cancel: 'Cancel',
    back: 'Back',
    user: 'User'
  },
  homeLayout: {
    navHome: 'Home',
    navProducts: 'Products',
    navNewArrivals: 'New Arrivals',
    navMyFavorites: 'My Favorites',
    login: 'Login',
    inquiry: 'Inquiry',
    inquiryWithCount: 'Inquiry ({count}{cbm})',
    cartCbmSuffix: ' / CBM: {value}',
    searchKeyword: 'Keyword',
    searchOemNumber: 'OEM number',
    searchPartNumber: 'Part number',
    placeholderKeyword: 'Search keyword',
    placeholderOemNumber: 'Search for OEM number',
    placeholderPartNumber: 'Search for part number',
    productDetailFallback: 'Product detail',
    loginFirst: 'Please log in first',
    floatingCartDetails: 'Details',
    favoriteCategory: 'Favorite category',
    unfavoriteCategory: 'Unfavorite',
    favoriteSuccess: 'Category favorited',
    unfavoriteSuccess: 'Removed from favorites',
    favoriteFailed: 'Failed to favorite, please retry',
    unfavoriteFailed: 'Failed to unfavorite, please retry',
    favoritesEmptyNav: 'No favorite categories yet',
    favoritesSelectCategory: 'Select a favorite category to view products',
    noYearCategories: 'No model years available'
  },
  homePage: {
    addToInquiry: 'Add to Inquiry',
    loading: 'Loading...',
    noMore: 'No more',
    pullToLoadMore: 'Pull to load more',
    inquiryList: 'Inquiry List',
    productDetails: 'Product Details',
    contactSalesTeam: 'Contact Sales Team',
    cancel: 'Cancel',
    generateInquiryList: 'Generate Inquiry',
    aboutUs: 'About Us',
    customerService: 'Customer Service',
    fits: 'Fits',
    sku: 'SKU',
    fobShanghai: 'FOB Shanghai:',
    qty: 'Qty:',
    amount: 'Amount:',
    wechat: 'WeChat',
    whatsapp: 'WhatsApp',
    rfqTip: 'Share your RFQ with us on WeChat or WhatsApp, and we will get back to you with a precise quote promptly.',
    footerCompany: 'Company',
    footerContact: 'Contact',
    footerCareers: 'Careers',
    footerHelpCenter: 'Help Center',
    footerShipping: 'Shipping',
    footerReturns: 'Returns',
    footerFollowUs: 'Follow Us',
    weibo: 'Weibo',
    tiktok: 'TikTok',
    email: 'Email',
    footerContactTitle: 'Contact',
    hotline: 'Hotline',
    hours: 'Hours',
    allRightsReserved: 'All rights reserved.',
    side: 'Side:',
    left: 'L',
    right: 'R',
    selectSideFirst: 'Please select a side (L or R) first.'
  },
  productDetail: {
    price: 'Price: ',
    originalPrice: 'Original: ',
    productNo: 'Product No.',
    fits: 'Fits',
    oem: 'OEM',
    category: 'Category',
    stock: 'Stock',
    unit: 'Unit',
    spec: 'Spec',
    defaultSpec: 'Default',
    side: 'Side:',
    left: 'L',
    right: 'R',
    selectSideFirst: 'Please select a side (L or R) first.',
    productIdRequired: 'Product ID is required',
    loadFailedSimple: 'Failed to load product',
    loadFailedRetry: 'Failed to load product, please try again later',
    loginToInquiry: 'Please log in to add to inquiry',
    invalidProductInfo: 'Invalid product info',
    addInquirySuccess: 'Added to inquiry',
    addInquiryFailed: 'Failed to add to inquiry',
    addInquiryFailedRetry: 'Failed to add to inquiry, please try again later',
    attributes: 'Attributes',
    addToInquiry: 'Add to Inquiry',
    productDetails: 'Product Details',
    noProductDetails: 'No product details',
    loadFailed: 'Failed to load product'
  },
  route: {
    landing: 'Portal Home',
    home: 'Products',
    productDetail: 'Product Detail',
    newArrivals: 'New Arrivals',
    favorites: 'My Favorites'
  },
  tip: {
    loadMenuFailed: 'Failed to load menu',
    searchFailedRetry: 'Search failed. Please try again later.',
    productIdNotFound: 'The product ID does not exist.',
    loginBeforeAddToCart: 'Please log in before adding items to the shopping cart.',
    addProductToInquirySuccess: 'Added {name} to inquiry list',
    addInquiryFailed: 'Failed to add to inquiry',
    addInquiryFailedRetry: 'Failed to add to inquiry, please try again later',
    selectItemsToCheckout: 'Please select items to inquire',
    searchResultTitle: 'Search results: {keyword}',
    productListTitle: 'Product list',
    generatingConfirmOrder: 'Generating confirmation...',
    generateConfirmFailed: 'Failed to generate confirmation',
    generateConfirmFailedRetry: 'Failed to generate confirmation, please try again later',
    invalidOrderInfoRegenerate: 'Invalid order info, please generate again',
    invalidInquiryDataReselect: 'Invalid inquiry data, please select items again',
    inquiryGeneratedSuccess: 'Inquiry list generated successfully',
    orderSubmitFailed: 'Order submit failed',
    orderSubmitFailedRetry: 'Order submit failed, please try again later',
    loginFirst: 'Please log in first',
    loadProductsFailed: 'Failed to load products',
    loadProductsFailedRetry: 'Failed to load products, please try again later',
    orderIdRequired: 'Order ID is required',
    downloadQuotationFailed: 'Failed to download inquiry list',
    downloadQuotationFailedRetry: 'Failed to download inquiry list, please try again later',
    downloadingQuotation: 'Downloading inquiry list, please wait...',
    quotationDownloaded: 'Inquiry list downloaded successfully',
    verifyFailedLoginAgain: 'Verification failed, please login again',
    loginSuccess: 'Login successful',
    registerSuccessPleaseLogin: 'Registration successful, please login',
    emailCodeSent: 'Verification code has been sent to your email',
    resetEmailCodeSent: 'Password reset verification code has been sent to your email',
    resetPasswordSuccess: 'Password reset successfully, please login',
    wechatCopied: 'WeChat ID copied to clipboard',
    copyFailedManual: 'Copy failed, please copy manually: {text}',
    loadInquiryListFailed: 'Failed to load inquiry list',
    quantityUpdated: 'Quantity updated',
    quantityUpdateFailed: 'Failed to update quantity',
    quantityUpdateFailedRetry: 'Failed to update quantity, please try again later',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    deleteFailedRetry: 'Delete failed, please try again later',
    clearInquiryListConfirm: 'Clear the inquiry list?',
    clearInquiryListSuccess: 'Inquiry list cleared',
    clearFailed: 'Clear failed',
    clearFailedRetry: 'Clear failed, please try again later',
    failedGetUserInfo: 'Failed to get user info',
    logoutSuccess: 'Logged out successfully',
    failedLoadAddresses: 'Failed to load addresses',
    addressUpdated: 'Address updated',
    failedUpdateAddress: 'Failed to update address',
    failedUpdateAddressRetry: 'Failed to update address, please try again later',
    addressAdded: 'Address added',
    failedAddAddress: 'Failed to add address',
    failedAddAddressRetry: 'Failed to add address, please try again later',
    addressDeleted: 'Address deleted',
    failedDeleteAddress: 'Failed to delete address',
    failedDeleteAddressRetry: 'Failed to delete address, please try again later',
    setDefaultSuccess: 'Set as default successfully',
    failedSetDefaultAddress: 'Failed to set default address',
    failedSetDefaultRetry: 'Failed to set default, please try again later',
    failedLoadOrders: 'Failed to load orders',
    failedLoadOrdersRetry: 'Failed to load orders, please try again later',
    failedLoadOrderDetails: 'Failed to load order details',
    failedLoadOrderDetailsRetry: 'Failed to load order details, please try again later',
    orderCancelled: 'Order cancelled',
    failedCancelOrder: 'Failed to cancel order',
    failedCancelOrderRetry: 'Failed to cancel order, please try again later',
    orderDeleted: 'Order deleted',
    failedDeleteOrder: 'Failed to delete order',
    failedDeleteOrderRetry: 'Failed to delete order, please try again later',
    orderNumberEmpty: 'Order number is empty',
    orderNumberCopied: 'Order number copied to clipboard',
    copyFailedManualNoText: 'Copy failed, please copy manually',
    invalidOrderInfo: 'Invalid order info',
    failedExportQuotation: 'Failed to export quotation',
    failedExportQuotationRetry: 'Failed to export quotation, please try again later',
    quotationExportedSuccess: 'Quotation exported successfully',
    confirmLogout: 'Are you sure you want to log out?',
    confirmCancelOrder: 'Are you sure you want to cancel this order?',
    confirmDeleteOrder: 'Are you sure you want to delete this order? This cannot be undone.',
    confirmReceiveOrder: 'Are you sure you want to confirm receipt?',
    confirmDeleteAddress: 'Are you sure you want to delete "{name}"?',
    pleaseSelectOrders: 'Please select orders',
    noShippableOrders: 'No shippable orders in selection',
    deleteSelectedOrders: 'Delete selected orders?',
    paymentUnderDevelopment: 'Payment is under development...',
    confirmReceiptUnderDevelopment: 'Confirm receipt is under development...',
    exportingQuotation: 'Exporting quotation, please wait...',
    notice: 'Notice',
    ok: 'OK',
    cancel: 'Cancel',
    requestFailed: 'Request failed',
    sessionExpiredTitle: 'Confirm logout',
    sessionExpiredMessage: 'You have been logged out. You can cancel to stay on this page, or log in again.',
    reLogin: 'Log in again'
  },
  validation: {
    validUsernameRequired: 'Please enter a valid username',
    emailRequired: 'Please enter email address',
    validEmailRequired: 'Please enter a valid email',
    passwordMinLength: 'Password must be at least 3 characters',
    confirmPasswordRequired: 'Please confirm password',
    passwordNotMatch: 'Passwords do not match',
    validPhoneRequired: 'Please enter a valid phone number',
    emailCodeRequired: 'Please enter email verification code',
    emailCodeLength: 'Verification code must be 6 digits',
    phoneRequired: 'Please enter phone number',
    recipientNameRequired: 'Please enter recipient name',
    provinceRequired: 'Please enter province',
    cityRequired: 'Please enter city',
    districtRequired: 'Please enter district',
    detailAddressRequired: 'Please enter detail address'
  },
  landing: {
    tagline: 'Professional Auto Parts Online Inquiry Platform',
    browseProducts: 'Browse Products',
    videoTitle: 'How to Use the Platform',
    videoNotSupported: 'Your browser does not support video playback',
    videoPlaceholder: 'Platform introduction video coming soon',
    videoPlaceholderHint: 'Place the video file in static/video/',
    aboutTitle: 'About SKYAUTOMAX',
    aboutDesc: 'SKYAUTOMAX is an online auto parts inquiry platform for global customers. Search by OEM number, part number, or keyword, browse our extensive catalog, generate professional inquiry lists, and communicate efficiently with our sales team.',
    feature1: 'Extensive auto parts catalog with multi-dimensional search',
    feature2: 'Online inquiry list management with one-click quotation export',
    feature3: 'Real-time communication via WeChat / WhatsApp with sales team',
    feature4: 'Fully responsive on mobile and desktop — inquire anytime, anywhere',
    enterWithoutLogin: 'Browse products without logging in',
    newArrivals: 'New Arrivals',
    comingSoon: 'Coming Soon',
    showcaseOnlyHint: 'Homepage showcase only — not listed in product catalog',
    comingSoonHint: 'Preview only — inquiry not available',
    tagNew: 'New',
    tagComing: 'Coming Soon'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    welcomeBack: 'Welcome back',
    createAccount: 'Register',
    enterAccount: 'Enter your account',
    createAccountTip: 'Create your account',
    usernameOrEmail: 'Username or email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    phoneOptional: 'Phone (optional)',
    emailCode: 'Email verification code',
    sendEmailCode: 'Send code',
    resendEmailCode: 'Resend',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    resettingPassword: 'Resetting...',
    newPassword: 'New password',
    resetPasswordTitle: 'Reset password',
    resetPasswordTip: 'Enter your registered email to verify',
    backToLogin: 'Back to login',
    loggingIn: 'Logging in...',
    registering: 'Registering...',
    sendingCode: 'Sending...'
  },
  cart: {
    inquiryTitle: 'Inquiry',
    empty: 'Inquiry list is empty',
    goShopping: 'Go shopping',
    clearInquiry: 'Clear inquiry',
    selectedItems: 'Selected {count} item(s)',
    totalCbm: 'Total CBM:',
    totalAmount: 'Total:',
    checkout: 'Inquire',
    confirmDeleteItem: 'Are you sure to delete this item?',
    expandItems: 'Expand ({count} items)',
    collapseItems: 'Collapse',
    piecesUnit: 'pcs'
  },
  contact: {
    button: 'Contact Us',
    dialogTitle: 'Contact us',
    email: 'Email',
    address: 'Address',
    whatsapp: 'WhatsApp',
    wechat: 'Wechat',
    copy: 'Copy',
    wechatQrHint: 'Scan to add on WeChat',
    whatsappQrHint: 'Scan to chat on WhatsApp'
  },
  profile: {
    title: 'Profile',
    myOrders: 'My Orders',
    basicInfo: 'Basic Info',
    accountEnabled: 'Account enabled',
    accountDisabled: 'Account disabled',
    shippingAddress: 'Shipping Address',
    addAddress: 'Add Address',
    defaultTag: 'Default',
    zip: 'Zip',
    edit: 'Edit',
    setDefault: 'Set as default',
    del: 'Delete',
    noShippingAddress: 'No shipping address',
    allOrders: 'All Orders',
    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    shipped: 'Shipped',
    completed: 'Completed',
    closed: 'Closed',
    orderNo: 'Order No.',
    orderStatus: 'Order Status',
    paymentTime: 'Payment time',
    orderType: 'Order type',
    copyOrderNo: 'Copy order number',
    inquiryTime: 'Inquiry time',
    exportQuotation: 'Export Quotation',
    orderTotal: 'Order total: ',
    viewDetails: 'View Details',
    pay: 'Pay',
    cancelOrder: 'Cancel Order',
    confirmReceipt: 'Confirm Receipt',
    deleteOrder: 'Delete Order',
    noOrders: 'No orders',
    recipient: 'Recipient',
    phone: 'Phone',
    province: 'Province',
    city: 'City',
    district: 'District',
    detailAddress: 'Detail Address',
    postalCode: 'Postal Code',
    setAsDefault: 'Set as default',
    orderDetails: 'Order Details',
    submitOrder: 'Submit Order',
    payOrder: 'Pay Order',
    ship: 'Ship',
    review: 'Review',
    recipientInfo: 'Recipient Info',
    shippingAddressLabel: 'Shipping Address',
    productInfo: 'Product Info',
    image: 'Image',
    product: 'Product',
    priceSku: 'Price / SKU',
    attributes: 'Attributes',
    qty: 'Qty',
    subtotal: 'Subtotal',
    paymentInfo: 'Payment Info',
    subtotalLabel: 'Subtotal',
    shippingFee: 'Shipping',
    coupon: 'Coupon',
    points: 'Points',
    promotion: 'Promotion',
    discount: 'Discount',
    total: 'Total',
    paid: 'Paid',
    logistics: 'Logistics',
    carrier: 'Carrier',
    trackingNo: 'Tracking No.',
    fits: 'Fits',
    oem: 'OEM',
    partNumber: 'Parts Link NO.',
    itemsUnit: 'items',
    sku: 'SKU',
    loadOrderFailed: 'Failed to load order',
    unpaid: 'Unpaid',
    flashSale: 'Flash Sale',
    normalOrder: 'Normal',
    unknown: 'Unknown'
  },
  adminOrder: {
    search: 'Search',
    reset: 'Reset',
    ok: 'OK',
    cancel: 'Cancel',
    filterTitle: 'Search Filters',
    orderNo: 'Order No.',
    orderNoPlaceholder: 'Order number',
    receiver: 'Receiver',
    receiverPlaceholder: 'Name / Phone',
    submitTime: 'Submit time',
    selectDate: 'Select date',
    status: 'Status',
    all: 'All',
    orderType: 'Order type',
    source: 'Source',
    orderList: 'Order List',
    id: 'ID',
    user: 'User',
    amount: 'Amount',
    payment: 'Payment',
    actions: 'Actions',
    view: 'View',
    close: 'Close',
    ship: 'Ship',
    track: 'Track',
    delete: 'Delete',
    batchAction: 'Batch action',
    closeOrder: 'Close Order',
    note: 'Note',
    notePlaceholder: 'Enter note',
    noteRequired: 'Note is required',
    updatedSuccessfully: 'Updated successfully',
    deletedSuccessfully: 'Deleted successfully',
    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    shipped: 'Shipped',
    completed: 'Completed',
    closed: 'Closed',
    invalid: 'Invalid',
    unpaid: 'Unpaid',
    alipay: 'Alipay',
    wechat: 'WeChat',
    normal: 'Normal',
    flashSale: 'Flash Sale',
    pc: 'PC',
    app: 'APP',
    batchShip: 'Batch Ship',
    batchClose: 'Close Order',
    batchDelete: 'Delete Order',
    pleaseSelectOrders: 'Please select orders',
    noShippableOrders: 'No shippable orders in selection',
    deleteSelectedOrders: 'Delete selected orders?',
    notice: 'Notice'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en-US.js